function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.4
}, React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-2_svg__filter0_d)"
}, React.createElement("ellipse", {
  cx: 406.975,
  cy: 417.221,
  rx: 32.098,
  ry: 12.61,
  fill: "#D5D4D4"
}), React.createElement("ellipse", {
  cx: 406.975,
  cy: 417.221,
  rx: 32.098,
  ry: 12.61,
  stroke: "#969696",
  strokeWidth: 1.422
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-2_svg__filter1_d)",
  transform: "rotate(-2.013 404.109 397.733)"
}, React.createElement("ellipse", {
  cx: 404.109,
  cy: 397.733,
  rx: 17.768,
  ry: 6.878,
  fill: "#D5D4D4"
}), React.createElement("ellipse", {
  cx: 404.109,
  cy: 397.733,
  rx: 17.768,
  ry: 6.878,
  stroke: "#969696",
  strokeWidth: 1.422
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-2_svg__filter2_d)",
  transform: "rotate(6.088 406.975 386.843)"
}, React.createElement("ellipse", {
  cx: 406.975,
  cy: 386.843,
  rx: 10.317,
  ry: 4.012,
  fill: "#D5D4D4"
}), React.createElement("ellipse", {
  cx: 406.975,
  cy: 386.843,
  rx: 10.317,
  ry: 4.012,
  stroke: "#969696",
  strokeWidth: 1.422
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-2_svg__filter3_d)",
  transform: "rotate(-3.688 46.735 413.777)"
}, React.createElement("ellipse", {
  cx: 46.735,
  cy: 413.777,
  rx: 32.098,
  ry: 12.61,
  fill: "#D5D4D4"
}), React.createElement("ellipse", {
  cx: 46.735,
  cy: 413.777,
  rx: 32.098,
  ry: 12.61,
  stroke: "#969696",
  strokeWidth: 1.422
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-2_svg__filter4_d)",
  transform: "rotate(21.93 94.803 123.123)"
}, React.createElement("ellipse", {
  cx: 94.803,
  cy: 123.123,
  rx: 17.768,
  ry: 6.878,
  fill: "#D5D4D4"
}), React.createElement("ellipse", {
  cx: 94.803,
  cy: 123.123,
  rx: 17.768,
  ry: 6.878,
  stroke: "#969696",
  strokeWidth: 1.422
})), React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-2_svg__filter5_d)",
  transform: "rotate(-46.778 432.538 191.782)"
}, React.createElement("ellipse", {
  cx: 432.538,
  cy: 191.782,
  rx: 10.317,
  ry: 4.012,
  fill: "#D5D4D4"
}), React.createElement("ellipse", {
  cx: 432.538,
  cy: 191.782,
  rx: 10.317,
  ry: 4.012,
  stroke: "#969696",
  strokeWidth: 1.422
})));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "leaf-2_svg__filter0_d",
  x: 370.167,
  y: 403.9,
  width: 73.617,
  height: 34.642,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-2_svg__filter1_d",
  x: 381.375,
  y: 389.5,
  width: 45.469,
  height: 24.467,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-2_svg__filter2_d",
  x: 391.508,
  y: 380.976,
  width: 30.934,
  height: 19.732,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-2_svg__filter3_d",
  x: 9.138,
  y: 398.374,
  width: 75.195,
  height: 38.807,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-2_svg__filter4_d",
  x: 70.827,
  y: 109.181,
  width: 47.953,
  height: 35.883,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "leaf-2_svg__filter5_d",
  x: 417.544,
  y: 180.511,
  width: 29.988,
  height: 30.541,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgLeaf2 = function SvgLeaf2(props) {
  return React.createElement("svg", _extends({
    width: 518,
    height: 439,
    viewBox: "0 0 518 439",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTE4IiBoZWlnaHQ9IjQzOSIgdmlld0JveD0iMCAwIDUxOCA0MzkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIG9wYWNpdHk9IjAuNCI+CjxnIG9wYWNpdHk9IjAuNSIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZCkiPgo8ZWxsaXBzZSBjeD0iNDA2Ljk3NSIgY3k9IjQxNy4yMjEiIHJ4PSIzMi4wOTc2IiByeT0iMTIuNjA5OCIgZmlsbD0iI0Q1RDRENCIvPgo8ZWxsaXBzZSBjeD0iNDA2Ljk3NSIgY3k9IjQxNy4yMjEiIHJ4PSIzMi4wOTc2IiByeT0iMTIuNjA5OCIgc3Ryb2tlPSIjOTY5Njk2IiBzdHJva2Utd2lkdGg9IjEuNDIxODgiLz4KPC9nPgo8ZyBvcGFjaXR5PSIwLjUiIGZpbHRlcj0idXJsKCNmaWx0ZXIxX2QpIj4KPGVsbGlwc2UgY3g9IjQwNC4xMDkiIGN5PSIzOTcuNzMzIiByeD0iMTcuNzY4MyIgcnk9IjYuODc4MDciIHRyYW5zZm9ybT0icm90YXRlKC0yLjAxMjY5IDQwNC4xMDkgMzk3LjczMykiIGZpbGw9IiNENUQ0RDQiLz4KPGVsbGlwc2UgY3g9IjQwNC4xMDkiIGN5PSIzOTcuNzMzIiByeD0iMTcuNzY4MyIgcnk9IjYuODc4MDciIHRyYW5zZm9ybT0icm90YXRlKC0yLjAxMjY5IDQwNC4xMDkgMzk3LjczMykiIHN0cm9rZT0iIzk2OTY5NiIgc3Ryb2tlLXdpZHRoPSIxLjQyMTg4Ii8+CjwvZz4KPGcgb3BhY2l0eT0iMC41IiBmaWx0ZXI9InVybCgjZmlsdGVyMl9kKSI+CjxlbGxpcHNlIGN4PSI0MDYuOTc1IiBjeT0iMzg2Ljg0MyIgcng9IjEwLjMxNzEiIHJ5PSI0LjAxMjIxIiB0cmFuc2Zvcm09InJvdGF0ZSg2LjA4ODI5IDQwNi45NzUgMzg2Ljg0MykiIGZpbGw9IiNENUQ0RDQiLz4KPGVsbGlwc2UgY3g9IjQwNi45NzUiIGN5PSIzODYuODQzIiByeD0iMTAuMzE3MSIgcnk9IjQuMDEyMjEiIHRyYW5zZm9ybT0icm90YXRlKDYuMDg4MjkgNDA2Ljk3NSAzODYuODQzKSIgc3Ryb2tlPSIjOTY5Njk2IiBzdHJva2Utd2lkdGg9IjEuNDIxODgiLz4KPC9nPgo8ZyBvcGFjaXR5PSIwLjUiIGZpbHRlcj0idXJsKCNmaWx0ZXIzX2QpIj4KPGVsbGlwc2UgY3g9IjQ2LjczNTMiIGN5PSI0MTMuNzc3IiByeD0iMzIuMDk3NiIgcnk9IjEyLjYwOTgiIHRyYW5zZm9ybT0icm90YXRlKC0zLjY4NzgzIDQ2LjczNTMgNDEzLjc3NykiIGZpbGw9IiNENUQ0RDQiLz4KPGVsbGlwc2UgY3g9IjQ2LjczNTMiIGN5PSI0MTMuNzc3IiByeD0iMzIuMDk3NiIgcnk9IjEyLjYwOTgiIHRyYW5zZm9ybT0icm90YXRlKC0zLjY4NzgzIDQ2LjczNTMgNDEzLjc3NykiIHN0cm9rZT0iIzk2OTY5NiIgc3Ryb2tlLXdpZHRoPSIxLjQyMTg4Ii8+CjwvZz4KPGcgb3BhY2l0eT0iMC41IiBmaWx0ZXI9InVybCgjZmlsdGVyNF9kKSI+CjxlbGxpcHNlIGN4PSI5NC44MDMiIGN5PSIxMjMuMTIzIiByeD0iMTcuNzY4MyIgcnk9IjYuODc4MDciIHRyYW5zZm9ybT0icm90YXRlKDIxLjkzMDIgOTQuODAzIDEyMy4xMjMpIiBmaWxsPSIjRDVENEQ0Ii8+CjxlbGxpcHNlIGN4PSI5NC44MDMiIGN5PSIxMjMuMTIzIiByeD0iMTcuNzY4MyIgcnk9IjYuODc4MDciIHRyYW5zZm9ybT0icm90YXRlKDIxLjkzMDIgOTQuODAzIDEyMy4xMjMpIiBzdHJva2U9IiM5Njk2OTYiIHN0cm9rZS13aWR0aD0iMS40MjE4OCIvPgo8L2c+CjxnIG9wYWNpdHk9IjAuNSIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjVfZCkiPgo8ZWxsaXBzZSBjeD0iNDMyLjUzOCIgY3k9IjE5MS43ODIiIHJ4PSIxMC4zMTcxIiByeT0iNC4wMTIyMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ2Ljc3NzcgNDMyLjUzOCAxOTEuNzgyKSIgZmlsbD0iI0Q1RDRENCIvPgo8ZWxsaXBzZSBjeD0iNDMyLjUzOCIgY3k9IjE5MS43ODIiIHJ4PSIxMC4zMTcxIiByeT0iNC4wMTIyMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ2Ljc3NzcgNDMyLjUzOCAxOTEuNzgyKSIgc3Ryb2tlPSIjOTY5Njk2IiBzdHJva2Utd2lkdGg9IjEuNDIxODgiLz4KPC9nPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2QiIHg9IjM3MC4xNjciIHk9IjQwMy45IiB3aWR0aD0iNzMuNjE3MiIgaGVpZ2h0PSIzNC42NDE1IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+CjxmZU9mZnNldCBkeT0iNCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjEgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyMV9kIiB4PSIzODEuMzc1IiB5PSIzODkuNSIgd2lkdGg9IjQ1LjQ2ODgiIGhlaWdodD0iMjQuNDY2NyIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIvPgo8ZmVPZmZzZXQgZHk9IjQiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMiIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4xIDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3ciLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjxmaWx0ZXIgaWQ9ImZpbHRlcjJfZCIgeD0iMzkxLjUwOCIgeT0iMzgwLjk3NiIgd2lkdGg9IjMwLjkzMzYiIGhlaWdodD0iMTkuNzMyMyIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIvPgo8ZmVPZmZzZXQgZHk9IjQiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMiIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4xIDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3ciLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjxmaWx0ZXIgaWQ9ImZpbHRlcjNfZCIgeD0iOS4xMzc3IiB5PSIzOTguMzc0IiB3aWR0aD0iNzUuMTk0OSIgaGVpZ2h0PSIzOC44MDY4IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+CjxmZU9mZnNldCBkeT0iNCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjEgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyNF9kIiB4PSI3MC44MjY3IiB5PSIxMDkuMTgxIiB3aWR0aD0iNDcuOTUyOSIgaGVpZ2h0PSIzNS44ODI5IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+CjxmZU9mZnNldCBkeT0iNCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjEgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyNV9kIiB4PSI0MTcuNTQ0IiB5PSIxODAuNTExIiB3aWR0aD0iMjkuOTg4MiIgaGVpZ2h0PSIzMC41NDE0IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+CjxmZU9mZnNldCBkeT0iNCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjEgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgLeaf2 as ReactComponent };